import { Grid, Divider, Tooltip, Box } from "@mui/material";
import { useRef, useState, useEffect } from "react";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import { FormProvider, useForm } from "react-hook-form";
import { TextBoxItem } from "components/Input/TextBox";
import Typography from "@mui/material/Typography";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import UploadFileItem from "components/Input/UploadFile";
import { BtnBack, BtnPreview, BtnSave } from "components/Button/ButtonAll";
import { useNavigate, useLocation } from "react-router";
import TextOption, { CallColoPicker } from "../AdminBanner/TextOption/TextOption";
import { TextAreaItem } from "components/Input/TextArea";
import SwitchFormItem from "components/Input/Switch";
import moment from "moment";
import { CheckBoxItem } from "components/Input/Checkbox/CheckBoxItem";
import { ICheckboxItem } from "components/Input/Checkbox/CheckboxProps";
import { APIStatusCode, I18NextNs } from "enum/enum";
import _ from "lodash";
import GalleryPreview from "./GalleryPreview";
import DialogPreview from "components/DialogPreview/DialogPreview";
import { Close } from "@mui/icons-material";
import { getMonthNameTH, toA, toB, toG, toR } from "components/ConvertData/ConvertData";
import { SelectItem } from "components/Input/Select/SelectItem";
import { GetMenuPermission } from "utilities/SystemFunction";

const GallerySettingForm = () => {
    const handleClearAttachFile = useRef(null);
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get("Gallery");
    const [arrCoverFile, setArrCoverFile] = useState([]);
    const [arrFile, setarrFile] = useState([]);
    const [nAllPin, setAllPin] = useState(0);
    const [IsTextOption, setIsTextOption] = useState(false);
    const [DropdownTextPos, setDropdownTextPos] = useState([]);
    const [DropdownFontSize, setDropdownFontSize] = useState([]);
    const [sPlacement, setsPlacement] = useState(null);
    const [IsShowPreview, setIsShowPreview] = useState<boolean>(false);
    const [activeId, setActiveId] = useState(null);
    const [nFileSize, setFileSize] = useState(0);
    const [FontColor, setFontColor] = useState([
        {
            displayColorPicker: false,
            defaultColor: "#000999",
            changeColor: "#000999",
            color:
            {
                r: "0",
                g: "9",
                b: "153",
                a: "1"
            },
            nID: "",
            id: 0
        }]);
    const [FontColorHead, setFontColorHead] = useState([
        {
            displayColorPicker: false,
            defaultColorHead: "#000999",
            changeColorHead: "#000999",
            color:
            {
                r: "0",
                g: "9",
                b: "153",
                a: "1"
            },
            nID: "",
            id: 0
        }]);

    const [arrTextOption, setArrTextOption] = useState([
        {
            nID: 1,
            sHeadline: "",
            sHeadlineFont: null,
            sHeadlineColor: null,
            nHeadlineSize: null,
            nTextOptionID: null,
            sTextMode: "N",
        },
    ] as any);

    const [arrTextOptionHead, setArrTextOptionHead] = useState([
        {
            nID: 1,
            sHeadlineHead: "",
            sHeadlineFontHead: null,
            sHeadlineColorHead: null,
            nHeadlineSizeHead: null,
            nTextOptionID: null,
            sTextMode: "N",
        },
    ] as any);

    const fontColor = "rgba(0, 9, 153, 1)";
    const [
        isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
    });

    const handleShowColorPicker = (nID, id) => {
        let arr = FontColorHead;
        arr.forEach(element => {
            element.displayColorPicker = true;
            element.nID = nID;
            element.id = id
        });
        setFontColorHead([...arr])
        setActiveId(nID);
    }

    const handleCloseColorPicker = (nID, id) => {
        let arr = FontColorHead;

        arr.forEach(element => {
            element.displayColorPicker = false;
            element.nID = nID;
            element.id = id
        });
        setFontColorHead([...arr])
    }

    const onChangeColorPicker = (color, sRowColor, id) => {
        let arr = FontColorHead;
        arr.forEach(element => {
            element.color = color.rgb;
            element.changeColorHead = color.hex;
        });
        setFontColorHead([...arr])
        arrTextOptionHead.forEach((item, i) => {
            form.setValue(sRowColor, color.hex)
        });

        arrTextOptionHead[id].sHeadlineColorHead = color.hex ?? form.getValues(sRowColor);
        setArrTextOptionHead([...arrTextOptionHead]);
    }

    const dStartDateBE = new Date((moment(form.getValues("dStartDate")).year() + 543), moment(form.getValues("dStartDate")).month(), moment(form.getValues("dStartDate")).date());
    let sDate = moment(dStartDateBE).format("DD") + ""
    const dStartDateBEConvertMonth = parseInt(sDate, 10) + " " + getMonthNameTH(dStartDateBE.getMonth()) + " " + moment(dStartDateBE).format("YYYY");

    const getFormInitial = () => {
        AxiosFn.Get(`GallerySetting/GetFormInitial`, {}, (result) => {
            setDropdownFontSize(result.objResult.lstTextSize)
            setDropdownTextPos(result.objResult.lstTextPosition)
        });
    }

    const getData = () => {
        let param = {
            sID: sID
        }
        AxiosFn.Post(`GallerySetting/GetGalleryDetail`, param, (result) => {
            let lstResult = result.objResult.ObjGalleryFromID;

            //count all pined gallery
            setAllPin(result.objResult.nCountAllPin)
            form.setValue("isPin", false)
            if (sID !== null) {
                setTimeout(() => {
                    form.setValue("sTextOption", false);
                }, 200);
                form.setValue("dStartDate", lstResult.sStartDate ? moment(lstResult.nStartDate) : null);
                form.setValue("dEndDate", lstResult.sEndDate ? moment(lstResult.nEndDate) : null);

                //head color
                if (lstResult.lstHeadlineOptionHead.length > 0) {
                    let lstTextOptionHead = [];
                    (lstResult.lstHeadlineOptionHead).forEach((item) => {
                        let ObjData = {
                            nID: item.nID,
                            sHeadlineHead: "",
                            sHeadlineColorHead: item.sFontColor,
                            nHeadlineSizeHead: item.nFontSize,
                            sHeadlineFontHead: item.nFontSize + "",
                            nTextOptionID: null,
                            sTextMode: "N",
                        };
                        lstTextOptionHead.push(ObjData);
                    });
                    setTimeout(() => {
                        setArrTextOptionHead(lstTextOptionHead);
                    }, 200);

                    let lstFontPicker = [];
                    (lstResult.lstHeadlineOptionHead).forEach((item, i) => {
                        let ObjFontPicker = {
                            displayColorPicker: true,
                            changeColorHead: item.sFontColor,
                            color:
                            {
                                r: '' + toR(item.sFontColor),
                                g: '' + toG(item.sFontColor),
                                b: '' + toB(item.sFontColor),
                                a: '' + toA(item.sFontColor)
                            },
                            nID: `sHeadlineColorHead_${i + 1}`,
                            id: 0
                        };
                        lstFontPicker.push(ObjFontPicker);
                    });

                    let objSetColor = {
                        rgb: lstFontPicker[0].color,
                        hex: lstFontPicker[0].changeColorHead,
                    }
                    onChangeColorPicker(objSetColor, lstFontPicker[0].nID, lstFontPicker[0].id)
                }

                //cover color
                if (lstResult.lstHeadlineOption.length > 0 && lstResult.lstHeadlineOption[0].sMoreDescription !== null) {
                    setIsTextOption(true);
                    setTimeout(() => {
                        form.setValue("sTextOption", true);
                    }, 200);
                    let nTextPositionID = null;
                    let lstTextOption = [];

                    (lstResult.lstHeadlineOption).forEach((item) => {
                        nTextPositionID = item.nTextPositionID;
                        let ObjData = {
                            nID: item.nID,
                            sHeadline: item.sMoreDescription,
                            sHeadlineFont: item.sFontColor,
                            sHeadlineColor: item.sFontColor,
                            nHeadlineSize: item.nFontSize,
                            nTextOptionID: item.nTextPositionID,
                            //sTextPosition: lstResult.sTextPosition,
                        };
                        lstTextOption.push(ObjData);
                    });
                    setArrTextOption(lstTextOption);
                    setsPlacement(nTextPositionID);
                }

                setArrCoverFile(lstResult.arrCoverFile);
                let lstPicOrder = lstResult.arrPicFile.sort((a, b) => a.nOrder - b.nOrder);
                setarrFile(lstPicOrder);

                form.setValue("sGalleryName", lstResult.sGalleryName);
                form.setValue("sGalleryDescription", lstResult.sCoverDescription);
                form.setValue("isPin", lstResult.isPin)
                form.setValue("isActive", lstResult.isActive)
            }
        });
    }

    const DefaultDataPicture = () => {
        let data: ICheckboxItem[] = [
            {
                label: (arrTextOption || []).length === 0
                    ? I18n.SetText(`enableupload`, I18NextNs.translation) + "ข้อความบนภาพ"
                    : "เพิ่มข้อความบนภาพ", value: "1"
            }
        ];
        return data;
    };

    const handleChangePin = (e) => {
        // nMode: 1 = change pin, 2 = save
        let param = {
            sID: sID,
            isPin: e,
            nMode: 1
        }

        AxiosFn.Post(`GallerySetting/OnChangePinInForm`, param, (result) => {
            if (result.nStatusCode === 200) {
                //count all pined gallery
                setAllPin(result.objResult.nCountAllPin)
            } else {
                DialogFn.Warning("ไม่สามารถปักหมุดได้เกิน 4 อัลบั้ม");
                form.setValue("isPin", false)
            }
        }, (err) => {
            DialogFn.Warning(err.Message);
        });
    }

    const handdleSubmit = () => {
        if (arrCoverFile.length === 0) {
            return DialogFn.Warning(I18n.SetText("UploadFile.sMsgRequiredFile", I18NextNs.labelComponent) + " ภาพปก");
        }
        if (arrFile.length === 0) {
            return DialogFn.Warning(I18n.SetText("UploadFile.sMsgRequiredFile", I18NextNs.labelComponent) + " รูปภาพของอัลบั้ม");
        }

        let param = {
            sID: sID ?? "",
            sGalleryName: form.getValues("sGalleryName"),
            sDescription: form.getValues("sGalleryDescription"),
            nStartDate: form.getValues("dStartDate") ? form.getValues("dStartDate").valueOf() : 0,
            nEndDate: form.getValues("dEndDate") ? form.getValues("dEndDate").valueOf() : 0,
            fFileCover: arrCoverFile ?? [],
            sCoverDescription: form.getValues("sCoverDescription"),
            sTextColor: form.getValues("sTextColor_"),
            arrTextSize: form.getValues("arrTextSize"),
            arrPlacement: form.getValues("arrPlacement"),
            fFilePic: arrFile ?? [],
            isPin: form.getValues("isPin"),
            isActive: form.getValues("isActive"),
            lstHeadlineOption: arrTextOption,
            lstHeadlineOptionHead: arrTextOptionHead,
            isAddText: IsTextOption,
            nPlacement: sPlacement,
        };

        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`GallerySetting/SaveGallery`, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success) {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        navigate(`/GallerySettingList`);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    }

    useEffect(() => {
        getFormInitial();
        getData();
    }, []);

    useEffect(() => { }, [nAllPin]);

    useEffect(() => {
        if (arrTextOptionHead != null) {
            arrTextOptionHead.forEach((item, i) => {
                form.setValue(`sHeadlineColorHead_${i + 1}`, item.sHeadlineColorHead);
                form.setValue(`nHeadlineSizeHead_${i + 1}`, item.nHeadlineSizeHead);
            });
        }
    }, [arrTextOptionHead]);

    return (
        <FormProvider {...form}>
            <Grid>
                <TextBoxItem
                    name="sGalleryName"
                    label='ชื่ออัลบั้ม'
                    maxLength={150}
                    id={"sGalleryName"}
                    required={true}
                    type={'text'}
                    disabled={!isPermission}
                />
            </Grid>
            <Grid sx={{ mt: "2%", mb: "2%" }}>
                <TextAreaItem
                    id={"sGalleryDescription"}
                    name="sGalleryDescription"
                    label='คำอธิบายอัลบั้ม'
                    maxLength={200}
                    maxRows={2}
                    required={false}
                    disabled={!isPermission}
                />
            </Grid>

            {/* Date */}
            <Grid container sx={{ mt: "1%" }}>
                <Typography sx={{ mt: "0.5%", mx: "1%" }}>วันที่กิจกรรม <span style={{ color: "red" }}> *</span></Typography>

                <Grid item xs={12} md={1.5}>
                    <DatePickerItem
                        disabled={!isPermission}
                        name={"dStartDate"}
                        id={"dStartDate"}
                        label={"วันที่เริ่มต้น"}
                        required={true}
                        maxDate={form.watch("dEndDate")}
                    />
                </Grid>

                <Typography sx={{ mt: "0.5%", mx: "1%" }}>-</Typography>

                <Grid item xs={12} md={1.5} sx={{ mr: "1%" }}>
                    <DatePickerItem
                        disabled={!isPermission}
                        name={"dEndDate"}
                        id={"dEndDate"}
                        label={"วันที่สิ้นสุด"}
                        required={true}
                        minDate={form.watch("dStartDate")}
                    />
                </Grid>

                {/* head color */}
                <Grid item xs={12} md={7}>
                    {(arrTextOptionHead).filter((f) => f.sTextMode !== "D")
                        .map((m, i) => (
                            i === 0 ?
                                <Grid key={m.nID} item container xs={12} md={12} spacing={1.5} justifyContent={"start"} alignItems={"start"}>
                                    <Grid item xs={3.5}>
                                        <Box
                                            sx={{
                                                color: fontColor,
                                                position: "relative"
                                            }}
                                            className="Box-content-form-color"
                                        >
                                            <TextBoxItem
                                                id={`sHeadlineColorHead_${i + 1}`}
                                                name={`sHeadlineColorHead_${i + 1}`}
                                                label={"-- " + "สีชื่ออัลบั้ม" + " --"}
                                                disabled={!isPermission}
                                                maxLength={7}
                                                defaultValue={FontColorHead.length !== 0 ? FontColorHead[0].changeColorHead : null}
                                                onChange={(e) => {
                                                    arrTextOptionHead[i].sHeadlineColorHead = e.target.value ?? form.getValues(`sHeadlineColorHead_${i + 1}`);
                                                    setArrTextOptionHead([...arrTextOptionHead]);
                                                }}
                                                onClick={(e) => {
                                                    handleShowColorPicker(`sHeadlineColorHead_${i + 1}`, i);
                                                }}
                                                type="text"
                                            />
                                            <Box sx={{ position: "absolute" }}>
                                                <CallColoPicker
                                                    FontColor={FontColorHead}
                                                    handleCloseColorPicker={handleCloseColorPicker}
                                                    onChangeColorPicker={onChangeColorPicker}
                                                    id={`sHeadlineColorHead_${i + 1}`}
                                                    activeId={activeId}
                                                />
                                            </Box>

                                        </Box>
                                    </Grid>

                                    {/* font size */}
                                    <Grid item xs={3.5}>
                                        <Box
                                            sx={{
                                                color: fontColor,
                                            }}
                                            className="Box-content-form"
                                        >
                                            <SelectItem
                                                id={`nHeadlineSizeHead_${i + 1}`}
                                                name={`nHeadlineSizeHead_${i + 1}`}
                                                label={
                                                    "-- " + "ขนาดชื่ออัลบั้ม" + " --"
                                                }
                                                required={false}
                                                disabled={!isPermission}
                                                options={DropdownFontSize}
                                                onChange={(e) => {
                                                    arrTextOptionHead[i].nHeadlineSizeHead =
                                                        e != null ? e.value : e;
                                                    setArrTextOptionHead([...arrTextOptionHead]);
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                    {i !== 0 && (
                                        <Grid
                                            item
                                            xs={2}
                                            sm={1}
                                            display={"flex"}
                                            alignItems={"center"}
                                        >
                                            <Box
                                                sx={{
                                                    color: "rgb(52, 71, 103)",
                                                }}
                                                className=".Box-content-form"
                                            >
                                            </Box>
                                        </Grid>
                                    )}
                                </Grid>
                                : null
                        ))}
                </Grid>
            </Grid>

            <Grid xs={12} sx={{ mt: "2%" }}>
                <UploadFileItem
                    required={true}
                    modeDisplay={"gallery"}
                    id={"GalleryCover"}
                    name={"GalleryCover"}
                    arrFile={arrCoverFile}
                    setarrFile={setArrCoverFile}
                    Extension={["jpg", "jpeg", "png"]}
                    nLimitFile={25}
                    sLimitFile={"MB"}
                    IsFolder={false}
                    onClearFile={handleClearAttachFile}
                    IsMultiple={false}
                    sPositionText="right"
                    sFolderTemp="GalleryCoverImage"
                    label="ภาพปกอัลบั้ม"
                    nRecommendWidth={1000}
                    nRecommendHeight={500}
                    disabled={!isPermission}
                />
            </Grid>

            <Grid container sx={{ mt: "4%" }}>
                <Grid item xs={12}>
                    <CheckBoxItem
                        name={'sTextOption'}
                        id={'sTextOption'}
                        disabled={(arrCoverFile || []).length === 0 || !isPermission}
                        required={false}
                        onChange={(value) => { setIsTextOption(value); }}
                        options={DefaultDataPicture()} />
                </Grid>
                {(arrCoverFile || []).length > 0 ? (
                    <TextOption
                        arrTextOption={arrTextOption}
                        setArrTextOption={setArrTextOption}
                        IsTextOption={IsTextOption}
                        FontColor={FontColor}
                        setFontColor={setFontColor}
                        DropdownFontSize={DropdownFontSize}
                        DropdownTextPos={DropdownTextPos}
                        IsView={false}
                        sPlacement={sPlacement}
                        setsPlacement={setsPlacement}
                        IsDisabled={!isPermission}
                    />
                ) : null}
            </Grid>

            <Grid xs={12} sx={{ mt: "2%" }}>
                <UploadFileItem
                    required={true}
                    modeDisplay={"card"}
                    id={"GalleryPic"}
                    name={"GalleryPic"}
                    arrFile={arrFile}
                    setarrFile={setarrFile}
                    Extension={["jpg", "jpeg", "png"]}
                    nLimitFile={25}
                    sLimitFile={"MB"}
                    IsFolder={true}
                    onClearFile={handleClearAttachFile}
                    IsMultiple={true}
                    sPopup={"modal"}
                    sPositionText="right"
                    sFolderTemp="GalleryCoverImage"
                    label="เพิ่มรูปภาพ"
                    nRecommendWidth={1000}
                    nRecommendHeight={500}
                    setFileSize={setFileSize}
                    nFileSize={nFileSize}
                    disabled={!isPermission}
                />
            </Grid>

            {/* pin */}
            <Grid sx={{ mt: "3%" }}>
                <Typography>ปักหมุด <span style={{ color: "#b6b6b7" }}>(จำนวนสูงสุด {nAllPin}/4 หมุด)</span></Typography>
            </Grid>
            <Divider />
            <Grid item xs={12} md={2} sx={{ mt: "2%" }}>
                <SwitchFormItem
                    name={"isPin"}
                    checkText='ปักหมุด'
                    uncheckText='ไม่ปักหมุด'
                    width={130}
                    id={"isPin"}
                    disabled={!isPermission}
                    onChange={(e) => { handleChangePin(e) }}
                />
            </Grid>

            {/* status */}
            <Grid sx={{ mt: "3%" }}>
                <Typography>สถานะ<span style={{ color: "red" }}> *</span></Typography>
            </Grid>
            <Divider />
            <Grid item xs={12} md={2} sx={{ mt: "2%", mb: "4%" }}>
                <SwitchFormItem
                    name={"isActive"}
                    checkText='ใช้งาน'
                    uncheckText='ไม่ใช้งาน'
                    width={130}
                    id={"isActive"}
                    disabled={!isPermission}
                />
            </Grid>

            {/* Button */}
            <Grid xs={12} container spacing={2} justifyContent={"start"} alignItems={"start"} style={{ paddingBottom: '2%', }}>
                <Grid item xs={12} md={6}>
                    <BtnBack id={"addHoliday"} txt={"ย้อนกลับ"} onClick={() => { navigate("/GallerySettingList"); }} />
                </Grid>
                <Grid item xs={12} md={6} container spacing={1} justifyContent="end" alignItems={"end"}>
                    <Grid item>
                        <BtnPreview
                            onClick={() => { setIsShowPreview(true); }}
                            id={'btnpreview'}
                        />
                    </Grid>
                    <Grid item>
                        <BtnSave id={"btnSave"}
                            IsDisabled={!isPermission}
                            onClick={form.handleSubmit((e) => { handdleSubmit() })}
                        />
                    </Grid>
                </Grid>
            </Grid>

            {/* preview gallery */}
            <DialogPreview
                IsOpen={IsShowPreview}
                IsBackdropClick={false}
                onClose={() => { setIsShowPreview(false); }}
                JsxDialogAction
                CloseSave={false}
                Close={false}
                sMaxWidth='lg'
                bgColor={"#a07300"}
                Color='white'
                Title={'ดูตัวอย่าง'}
                fullScreen={true}
                isDialogTitle={true}
            >
                <Grid item xs={12} md={12} container spacing={2} justifyItems={'flex-start'} justifyContent={'flex-start'} style={{ padding: '2%', }}>
                    <Grid container justifyContent={"end"}>
                        <Tooltip title={I18n.SetText("close")} placement="right" arrow style={{ zIndex: 100000 }}>
                            <div onClick={() => { setIsShowPreview(false); }} >
                                <Close
                                    fontSize='large'
                                    className='m-[auto] text-[white]'
                                    style={{
                                        color: 'blue',
                                        fontSize: '40px',
                                        cursor: 'pointer',
                                    }}
                                />
                            </div>
                        </Tooltip>
                    </Grid>
                    <Grid item container spacing={2} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
                        {(arrTextOptionHead)
                            .filter((f) => f.sTextMode !== "D")
                            .map((m, i) => (
                                <GalleryPreview
                                    arrGallery={arrFile.filter(f => f.IsCompleted && !f.IsDelete)}
                                    sName={form.getValues("sGalleryName") ?? "ชื่ออัลบั้ม"}
                                    sHeadDescription={form.getValues("sGalleryDescription")}
                                    sDate={dStartDateBEConvertMonth ? dStartDateBEConvertMonth : "วันที่กิจกรรม เริ่มต้น"}
                                    color={form.getValues(`sHeadlineColorHead_${i + 1}`)}
                                />
                            ))}
                    </Grid>
                </Grid>
            </DialogPreview>
        </FormProvider >
    );
}

export default GallerySettingForm;